module.exports = __webpack_public_path__ + "img/features-text-content-editor.f92b7c7e.png";